
import { NavItem } from '../types';
import { Megaphone, List, FileText } from 'lucide-react';

const campaignItems: NavItem[] = [
  {
    title: 'Campaign',
    path: '/app/campaigns',
    icon: Megaphone,
    requiredPermissions: ['campaign.read'],
    children: [
      {
        title: 'All Campaigns',
        path: '/app/campaigns',
        requiredPermissions: ['campaign.read'],
      },
      {
        title: 'Template',
        path: '/app/templates',
        requiredPermissions: ['template.read'],
      }
    ]
  }
];

export default campaignItems;
